import {
    DECREASE_AREA_THRESHOLD_PERCENTAGE,
    INCREASE_AREA_THRESHOLD_PERCENTAGE,
} from '@modules/encoding/modules/rotation/constants';

export const hasIncreasedArea = (delta: number) => delta > INCREASE_AREA_THRESHOLD_PERCENTAGE;
export const hasDecreasedArea = (delta: number) => delta < DECREASE_AREA_THRESHOLD_PERCENTAGE;
